// @flow

import * as React from 'react';
import {ButtonLink} from 'sail/Button';
import {DataTableCell, DataTableRow} from 'sail/DataTable';

import type {VideoModel} from 'docs/data';
import {PlaylistVideoStatus} from './PlaylistVideoStatus';

// Helper for converting from an integer seconds duration to a string.
// Note: Doesn't yet support hours.
// E.g.
//     convertTimeToString(5) //> "00:05"
//     convertTimeToString(50) //> "00:50"
//     convertTimeToString(500) //> "08:20"
//     convertTimeToString(3601) //> "60:01"
function convertTimeToString(time: number) {
  const minute = Math.floor(time / 60);
  const second = time - minute * 60;

  if (second < 10) {
    return `${minute.toString()}:0${second.toString()}`;
  }

  return `${minute.toString()}:${second.toString()}`;
}

type PlaylistVideoSelectorRowProps = {|
  video: VideoModel,
  index: number,
  onChangeVideo: (video: VideoModel) => any,
  selectedVideo: VideoModel,
|};

export const PlaylistVideoSelectorRow = ({
  video,
  index,
  onChangeVideo,
  selectedVideo,
}: PlaylistVideoSelectorRowProps) => {
  return (
    <DataTableRow key={index}>
      <DataTableCell
        align="center"
        vAlign="middle"
        className="VideoSelectorFirstCell"
      >
        <PlaylistVideoStatus
          video={video}
          index={index}
          selectedVideo={selectedVideo}
        />
      </DataTableCell>
      <DataTableCell
        width="maximized"
        emphasized
        vAlign="middle"
        className="VideoSelectorCell"
      >
        <ButtonLink
          onClick={() => onChangeVideo(video)}
          label={video?.title.substring(
            0,
            video?.title.indexOf(' with') > 0
              ? video?.title.indexOf(' with')
              : video?.title.length,
          )}
          wrap
        />
      </DataTableCell>
      <DataTableCell width={90} vAlign="middle" className="VideoSelectorCell">
        {convertTimeToString(video.duration || 0)}
      </DataTableCell>
    </DataTableRow>
  );
};
